// Richer decorative background — blobs, dot fields, sparkles, geometric shapes
export function BgOrnaments({ variant = "default" }) {
    const Sparks = ({ items }) => (
        <>
            {items.map((s, i) => (
                <span key={i} className={`orn-spark orn-float ${s.pos} ${s.size}`} style={{ animationDelay: s.delay || "0s" }}>✦</span>
            ))}
        </>
    );

    if (variant === "dots") {
        return (
            <>
                <div className="absolute inset-0 bg-dots opacity-50 pointer-events-none" style={{ maskImage: "radial-gradient(ellipse 65% 55% at 50% 50%, black 20%, transparent 80%)", WebkitMaskImage: "radial-gradient(ellipse 65% 55% at 50% 50%, black 20%, transparent 80%)" }} />
                <div className="absolute -top-24 -right-24 w-[280px] md:w-[400px] h-[280px] md:h-[400px] rounded-full blob-lime blur-3xl pointer-events-none" />
                <div className="absolute -bottom-32 -left-32 w-[300px] md:w-[420px] h-[300px] md:h-[420px] rounded-full blob-coral blur-3xl pointer-events-none opacity-60" />
                {/* Big soft rings */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] md:w-[600px] h-[420px] md:h-[600px] rounded-full border border-[#DFFF3D]/8 pointer-events-none" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] md:w-[900px] h-[640px] md:h-[900px] rounded-full border border-[#DFFF3D]/6 pointer-events-none" />
                <Sparks items={[
                    { pos: "top-20 right-6 md:right-16", size: "text-[46px] md:text-[80px]" },
                    { pos: "top-1/2 left-4 md:left-8", size: "text-[26px] md:text-[42px]", delay: "2s" },
                    { pos: "bottom-24 right-1/3", size: "text-[34px] md:text-[54px]", delay: "4s" },
                ]} />
            </>
        );
    }
    if (variant === "grid") {
        return (
            <>
                <div className="absolute inset-0 bg-grid-forest opacity-70 pointer-events-none" style={{ maskImage: "radial-gradient(ellipse 60% 50% at 50% 40%, black 20%, transparent 80%)", WebkitMaskImage: "radial-gradient(ellipse 60% 50% at 50% 40%, black 20%, transparent 80%)" }} />
                <div className="absolute -bottom-32 -left-32 w-[360px] md:w-[520px] h-[360px] md:h-[520px] rounded-full blob-lime blur-3xl pointer-events-none" />
                <div className="absolute -top-20 right-1/4 w-[260px] md:w-[380px] h-[260px] md:h-[380px] rounded-full blob-coral blur-3xl pointer-events-none opacity-60" />
                {/* Diagonal chartreuse svg */}
                <svg className="absolute top-4 right-2 w-[180px] h-[180px] md:w-[300px] md:h-[300px] opacity-30 pointer-events-none" viewBox="0 0 300 300">
                    <path d="M0 300 L300 0" stroke="#DFFF3D" strokeWidth="1" strokeDasharray="4 8" />
                    <circle cx="150" cy="150" r="40" fill="none" stroke="#DFFF3D" strokeWidth="1" strokeDasharray="4 6" />
                </svg>
                <Sparks items={[
                    { pos: "bottom-24 right-6 md:right-12", size: "text-[40px] md:text-[64px]" },
                    { pos: "top-40 left-6 md:left-1/4", size: "text-[24px] md:text-[36px]", delay: "3s" },
                ]} />
            </>
        );
    }
    // default
    return (
        <>
            <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[420px] md:w-[700px] h-[340px] md:h-[500px] blob-lime blur-3xl pointer-events-none" />
            <div className="absolute bottom-0 -right-20 w-[300px] md:w-[420px] h-[300px] md:h-[420px] rounded-full blob-coral blur-3xl pointer-events-none opacity-70" />
            <div className="absolute inset-0 bg-dots opacity-30 pointer-events-none" style={{ maskImage: "radial-gradient(ellipse 70% 50% at 50% 50%, black 30%, transparent 80%)", WebkitMaskImage: "radial-gradient(ellipse 70% 50% at 50% 50%, black 30%, transparent 80%)" }} />
            {/* Concentric SVG ring */}
            <svg className="absolute -bottom-20 -left-12 md:-left-24 w-[280px] h-[280px] md:w-[420px] md:h-[420px] opacity-30 pointer-events-none" viewBox="0 0 400 400">
                <circle cx="200" cy="200" r="90" fill="none" stroke="#DFFF3D" strokeWidth="1" strokeDasharray="2 6" />
                <circle cx="200" cy="200" r="150" fill="none" stroke="#DFFF3D" strokeWidth="1" strokeDasharray="2 8" opacity="0.6" />
                <circle cx="200" cy="200" r="200" fill="none" stroke="#DFFF3D" strokeWidth="1" strokeDasharray="2 10" opacity="0.35" />
            </svg>
            <Sparks items={[
                { pos: "top-16 left-4 md:left-10", size: "text-[34px] md:text-[54px]" },
                { pos: "bottom-32 right-8 md:right-24", size: "text-[26px] md:text-[42px]", delay: "3s" },
                { pos: "top-1/3 right-6 md:right-16", size: "text-[20px] md:text-[28px]", delay: "1.5s" },
            ]} />
        </>
    );
}
export default BgOrnaments;
